import {ShipmentStatus} from '../model/shipment-status.enum';

export class ShipmentStatusService {
  private shipmentStatus: {[key: string]: string} =
    {
      [ShipmentStatus.STORED]: 'created',
      [ShipmentStatus.CREATED]: 'created',
      [ShipmentStatus.CONFIRMED]: 'confirmed',
      [ShipmentStatus.PRE_TRANSPORT]: 'confirmed',
      [ShipmentStatus.IN_TRANSIT]: 'pickup',
      [ShipmentStatus.PICKUP]: 'pickup',
      [ShipmentStatus.DESTINATION_HANDLING]: 'pickup',
      [ShipmentStatus.DELIVERED]: 'delivered',
      [ShipmentStatus.FAILED]: 'failed',
      [ShipmentStatus.EXCEPTION]: 'failed',
      [ShipmentStatus.NOT_CONFIRMED]: null,
      [ShipmentStatus.CANCELED]: null,
    }
  ;

  private shipmentColors = {
    created: '#d8d9d8',
    confirmed: '#f7a948',
    pickup: '#68b8e8',
    delivered: '#30dc9f',
    failed: '#f94b59'
  };


  public getColorByStatus = (status: string) => {
    return this.shipmentStatus[status] && this.shipmentColors[this.shipmentStatus[status]];
  }

}



// WEBPACK FOOTER //
// ./src/app/services/shipment-status.service.ts